<template>
  <div >
    <div class="content">
      <div class="logo"></div>

      <el-alert
          title="为了您的账户号安全，请绑定您的手机号"
          type="warning"
          :closable="false"
      >
      </el-alert>

      <div class="input-wrap" :class='borderFlag?"have-border":""'>
        <label for="phone" class="title">手机号码</label>
        <cube-input v-model="info.account" placeholder="请输入您的手机号"  type="tel"  id="phone" @input="onMobileInput" :maxlength="maxTel"></cube-input>
      </div>

      <div class="identify_no_wrap idCard">
        <div class="input-wrap" :class='borderMark?"have-border":""'>
          <label for="identify-no" class="title">验证码</label>
          <cube-input v-model="info.code" placeholder="请输入验证码" type="tel" id="identify-no" @input="onCodeInput" :maxlength="maxCode"></cube-input>
        </div>
        <div :class="{get_code_btn: true, can_get_code: canGetCode}" @click="getCode" v-if="!isGettingCode">{{text}}</div>
        <div :class="{get_code_btn:true, cannot_get_code: !canGetCode}" v-if="isGettingCode">重新发送{{countDownSecond}}s</div>
      </div>

      <div :class="{loginBtn: true, canLogin: !isCodeEmpty && canGetCode}" @click="onLoginClick">确认绑定</div>
      <div class="xieYi">
        <span class="agree">绑定代表您已经同意</span>
        <span class="agreeText" @click="navigateTo('./agreement')">《绑定注册协议》</span>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import { getIdentifyCode, codeLogin,getCommunal} from '@/api/common'
import utils from '@/assets/jslibs/utils'
import {UpMinOpenid,WxBindAccount} from '@/api/common';
import wx from 'weixin-js-sdk'
import { mapMutations } from 'vuex'

export default {
  name: 'BindMobile',
  data() {
    return {
      info: {
        account: '',
        code: '',
      },
      maxTel:11,
      maxCode:4,
      countDownSecond: '',
      text: '获取验证码',
      isGettingCode: false,
      canGetCode: false,
      isCodeEmpty: true,
      timer: null,
      borderFlag:false,
      borderMark:false
    }
  },

  created(){
    this.getCommunal();
    sessionStorage.removeItem("peg");         //用户重新登录的时候，清除用户端展示模块的标示 登录后默认展示首页
    sessionStorage.removeItem("stamp");
    sessionStorage.removeItem("mark");
    sessionStorage.removeItem("sign");
    //utils.setCookie('X-Access-Token', '', 0);
    localStorage.removeItem('min_openid');

  },

  mounted(){
    document.title = "绑定手机号"
  },

  methods: {
    ...mapMutations(['update_expiry_time']),
    onMobileInput() {
      if (this.info.account.length >= 2) {
        this.borderFlag = true;
        this.borderMark = false;
      } else {
        this.borderFlag = false;
      }
      if (this.info.account.length >= 11) {
        this.canGetCode = true;
      } else {
        this.canGetCode = false;
      }
    },

    navigateTo(path) {
      this.$router.push(path)
    },

    onCodeInput() {
      if (this.info.code !== '') {
        this.isCodeEmpty = false;
      } else {
        this.isCodeEmpty = true;
      }
    },

    async getCode() {
      if (!this.canGetCode) return
      const { account } = this.info;
      if (!(/^1[0123456789]\d{9}$/.test(account))) {
        window.toast('手机号码有误', 'txt')
      } else {
        let obj = {
          type: '1',
          mobile: account
        }
        const { status } = await getIdentifyCode(obj);
        if (status !== 200) return
        this.borderMark = true;
        this.borderFlag = false;
        //显示60s倒计时
        this.countDown();
      }
    },

    async onLoginClick() {
      const { account } = this.info;
      //如果手机号 和验证码为空退出
      if (this.isCodeEmpty) return
      if (!this.canGetCode) return


      var WxUserInfo = utils.getSession('WxUserInfo');
      if (!WxUserInfo){
        window.toast('请返回登录重新登录', 'txt')
        return;
      }
      if (!(/^1[0123456789]\d{9}$/.test(account))) {
        window.toast('手机号码有误', 'txt')
      } else {
        const obj = {
          account: this.info.account,
          code: this.info.code,
          WxUserInfo:WxUserInfo,
          type:'Wxmin',
        };

        const { data , status } = await WxBindAccount(obj);
        if (status !== 200) return

        utils.setCookie('X-Access-Token', data.user_access_token.token, 7);
        this.update_expiry_time(data.user_access_token.expiry_time);
        this.$router.push('./index')
      }
    },

    //获取七牛信息
    async getCommunal() {
      const { data, status } = await getCommunal();
      if (status !== 200) return
      this.$store.commit("setImgUrl",data.BucketDomain);
      sessionStorage.setItem("imgUrl",data.BucketDomain);
    },


    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.countDownSecond = TIME_COUNT;
        this.isGettingCode = true;
        this.timer = setInterval(() => {
          if (this.countDownSecond > 0 && this.countDownSecond <= TIME_COUNT) {
            this.countDownSecond--;
          } else {
            this.text = '重新获取'
            this.isGettingCode = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
    },
  },
  components:{
    CommonHeader
  }
}
</script>

<style lang='less' scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
.content {
  .f-s(16);
  margin: 0 0.49333333rem 0 0.52rem;
  .header {
    .f-s(24);
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(20,20,20,1);
  }

  .logo{
    width:250px;
    height:100px;
    background: url(../assets/images/logo.png) no-repeat center center;
    background-size: 250px;
    margin: 0 auto;
    margin-top: 17px;
  }

  .have-border{
    border-bottom: 1px solid #4A90E2
  }

  .input-wrap {
    .m-t(10);
    .title {
      .f-s(15);
      .m-t(16);
      .m-b(10);
      display: block;
      font-family:PingFangSC-Regular;
      font-weight:500;
      color:rgba(20,20,20,1);
      font-size:0.42666667rem;
    }

    /deep/.cube-input {
      .w(335);
      /deep/.cube-input-field{
        padding: 0.266667rem 0;
        font-size: 0.3733333rem;
      }
    }

    /deep/.cube-input::after {
      border: 0;
      border-bottom: 1px solid #eee;
    }
  }

  .identify_no_wrap {
    display: flex;
    align-items: flex-end;
    /deep/.cube-input {
      .w(231);
    }

    .get_code_btn {
      .w(100);
      .h(40);
      .l-h(40);
      .f-s(13);
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(255,255,255,1);
      text-align: center;
      background:rgba(207,207,207,1);
      border-radius:2px;
    }

    .can_get_code {
      background:rgba(74,144,226,1);
    }
    .cannot_get_code {
      background:rgba(207,207,207,1);
    }
  }

  .xieYi{
    position: absolute;
    bottom: 0.4266667rem;
    left: 2.4266667rem;
    .agree{
      color: #666666;
      font-size: 0.32rem;
    }
    .agreeText{
      color: #141414;
      font-size: 0.32rem;
    }
  }

  .loginBtn {
    .h(46);
    .l-h(46);
    .w(337.5);
    .m-t(25);
    .f-s(16);
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align: center;
    background:rgba(193,193,193,1);
    border-radius:2px;
  }

  .canLogin {
    background:rgba(74,144,226,1);
  }
}
</style>
